export const downloadImageFromServer = async (
  imageUrl = "",
  canvasRef: any,
  setImageDownloading: any,
  imageDownloading: any
) => {
  if (!imageDownloading) {
    setImageDownloading(true);
    try {
      const canvas: any = canvasRef.current;
      if (canvas) {
        const ctx = canvas.getContext("2d");
        const response = await fetch(
          `${
            process.env.REACT_APP_BASE_URL
           }/api/fetch-image?url=${encodeURIComponent(imageUrl)}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const blob = await response.blob();
        const image = new Image();
        image.src = URL.createObjectURL(blob);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const link = document.createElement("a");
          link.download = "downloaded-image.png";
          link.href = canvas.toDataURL("image/png");
          link.click();
        };
      }
    } catch (error) {
      console.error("Error downloading the image:", error);
    } finally {
      setImageDownloading(false);
    }
  }
};
